import React from "react";
import { Box, Heading, Text, Button, VStack, Icon } from "@chakra-ui/react";
import { FiAlertTriangle } from "react-icons/fi";
import { useDashboardNavigate } from "../hooks/useDashboardNavigate";

export const ForbiddenPage: React.FC = () => {
  const goToDashboard = useDashboardNavigate();

  return (
    <Box
      minH="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      bg="gray.50"
      _dark={{ bg: "gray.900" }}
    >
      <VStack spacing={6} textAlign="center" px={4}>
        <Icon
          verticalAlign="middle"
          as={FiAlertTriangle as any}
          boxSize={20}
          color="secondary.500"
        />

        <Heading size="2xl" color="gray.700" _dark={{ color: "gray.200" }}>
          403
        </Heading>

        <Heading size="lg" color="gray.600" _dark={{ color: "gray.300" }}>
          دسترسی غیرمجاز
        </Heading>

        <Text color="gray.600" _dark={{ color: "gray.400" }} maxW="md">
          شما به این صفحه دسترسی ندارید. لطفاً با مدیر سیستم تماس بگیرید یا به
          پنل سرمایه گذار اصلی بازگردید.
        </Text>

        <Button colorScheme="brand" size="lg" onClick={goToDashboard}>
          بازگشت به پنل سرمایه گذار
        </Button>
      </VStack>
    </Box>
  );
};
